import { Injectable } from '@angular/core';
import { createStore, withProps } from '@ngneat/elf';
import type { DashboardX } from '#common/zod/backend/dashboard-x';
import { BaseQuery } from './base.query';

export type DashboardState = DashboardX;

let dashboardState: DashboardState = {
  structId: undefined,
  dashboardId: undefined,
  draft: true,
  creatorId: undefined,
  filePath: undefined,
  content: undefined,
  accessRoles: [],
  accessRolesCombined: [],
  title: undefined,
  extendedFilters: [],
  fields: [],
  tiles: [],
  serverTs: undefined,
  author: undefined,
  canEditOrDeleteDashboard: undefined,
  storeModels: undefined
};

@Injectable({ providedIn: 'root' })
export class DashboardQuery extends BaseQuery<DashboardX> {
  constructor() {
    super(
      createStore(
        { name: 'dashboard' },
        withProps<DashboardState>(dashboardState)
      )
    );
  }
}
